import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0C1620] border-t border-[#3A4F60]/30 py-8 sm:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 sm:gap-8">
          <div className="flex items-center gap-3 sm:gap-4 text-center md:text-left">
            <img
              src="/images/vmbs-logo.png"
              alt="VMBS UG Logo"
              className="h-10 w-10 sm:h-14 sm:w-14 object-contain"
            />
            <div>
              <span className="font-heading text-lg sm:text-2xl tracking-widest text-white font-semibold">
                V<span className="text-[#C5993A]">·</span>M<span className="text-[#C5993A]">·</span>B<span className="text-[#C5993A]">·</span>S
              </span>
              <p className="text-[#8899AA] text-xs sm:text-sm mt-1 font-light">
                Vermögensschutz mit physischen Edelmetallen
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm">
            <Link
              to="/impressum"
              data-testid="footer-impressum-link"
              className="text-[#8899AA] hover:text-[#C5993A] transition-colors"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              data-testid="footer-datenschutz-link"
              className="text-[#8899AA] hover:text-[#C5993A] transition-colors"
            >
              Datenschutzerklärung
            </Link>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="text-[#3A4F60] hover:text-[#8899AA] transition-colors"
            >
              Admin
            </Link>
          </div>
        </div>

        <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-[#3A4F60]/20 text-center">
          <p className="text-[#3A4F60] text-[10px] sm:text-xs">
            &copy; {new Date().getFullYear()} VMBS UG &middot; Ludwigstr. 9 &middot; 85298 Scheyern
          </p>
        </div>
      </div>
    </footer>
  );
}
